import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useSwipeable } from "react-swipeable";

const TeamMembers = ({ teamMembers }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animationDirection, setAnimationDirection] = useState("none");

  const handlePrev = () => {
    setAnimationDirection("left");
    setTimeout(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === 0 ? teamMembers.length - 1 : prevIndex - 1
      );
      setAnimationDirection("none");
    }, 300);
  };

  const handleNext = () => {
    setAnimationDirection("right");
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % teamMembers.length);
      setAnimationDirection("none");
    }, 300);
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: handleNext,
    onSwipedRight: handlePrev,
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  return (
    <div className="relative flex flex-col z-10 mb-24 items-center">
      {/* Section Header */}
      <h1 className="text-3xl font-bold text-center text-cyan-700 mt-14 mb-14">
        Conheça a nossa equipa!
      </h1>

      {/* Desktop Grid Layout */}
      <div className="hidden md:grid w-3/4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-12 px-12">
        {teamMembers.map((member) => (
          <div
            key={member.name}
            className="bg-white shadow-lg rounded-lg overflow-hidden text-center py-4 transition-transform transform hover:scale-105"
          >
            <a
              href={member.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group"
            >
              <img
                src={member.image}
                alt={member.name}
                className="w-48 h-48 rounded-full object-cover mx-auto mt-6 border-4 border-cyan-700 transition-transform duration-300 ease-in-out transform group-hover:scale-125"
              />
            </a>
            <div className="p-4">
              <h3 className="text-xl font-bold text-cyan-600 my-2">
                {member.name}
              </h3>
              <p className="text-cyan-600">{member.position}</p>
              <a
                href={member.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-cyan-600 rounded-lg"
              >
                <FontAwesomeIcon icon={faLinkedin} size="2x" />
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* Mobile Carousel */}
      <div
        {...swipeHandlers}
        className="block md:hidden w-full flex items-center justify-center relative"
      >
        <button
          onClick={handlePrev}
          className="absolute z-10 left-6 p-2 text-cyan-700 hover:bg-gray-200 rounded-full focus:outline-none"
        >
          <FontAwesomeIcon icon={faArrowLeft} size="2x" />
        </button>

        <div
          className={`relative w-72 md:w-80 bg-white border-2 border-cyan-600 rounded-lg shadow-lg text-center transition-transform duration-300 ease-in-out ${
            animationDirection === "right"
              ? "translate-x-full opacity-0"
              : animationDirection === "left"
              ? "-translate-x-full opacity-0"
              : "translate-x-0 opacity-100"
          }`}
        >
          <div className="w-full p-4 bg-white shadow-lg rounded-lg text-center">
            <a
              href={teamMembers[currentIndex]?.link || "#"}
              target="_blank"
              rel="noopener noreferrer"
              className="group"
            >
              <img
                src={teamMembers[currentIndex]?.image || ""}
                alt={teamMembers[currentIndex]?.name || "Team Member"}
                className="w-48 h-48 rounded-full object-cover mx-auto mt-6 border-4 border-cyan-700 transition-transform duration-300 ease-in-out transform group-hover:scale-125"
              />
            </a>
            <div className="p-4">
              <h3 className="text-xl font-bold text-cyan-600 my-2">
                {teamMembers[currentIndex]?.name || "Unknown"}
              </h3>
              <p className="text-cyan-600">
                {teamMembers[currentIndex]?.position || "Position"}
              </p>
              <a
                href={teamMembers[currentIndex]?.link || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className="text-cyan-600 rounded-lg"
              >
                <FontAwesomeIcon icon={faLinkedin} size="2x" />
              </a>
            </div>
          </div>
        </div>

        <button
          onClick={handleNext}
          className="absolute z-10 right-6 p-2 text-cyan-700 hover:bg-gray-200 rounded-full focus:outline-none"
        >
          <FontAwesomeIcon icon={faArrowRight} size="2x" />
        </button>
      </div>
    </div>
  );
};

export default TeamMembers;
